export const API_PATH = {
  signUp: 'auth/signup',
  signIn: 'auth/signin',
  users: 'users',
  boards: 'boards',
  boardsSet: 'boardsSet',
  columns: 'columns',
  columnsSet: 'columnsSet',
  tasksSet: 'tasksSet',
  points: 'points',
  file: 'file',
};
